const state = {
  statuses: [],
  validStatus: {},
  pageStatusCount: null,
  pageStatusCurrent: null,
};

export default state;
